import { EnrichedCustomerFrontEvent     ,
         UserSession                    ,
         LiveSession                    ,
         ReplaySession                  ,
         UrlRedirectionEvent                 ,
         VideoSegment                   ,
         GetSessionsParams              ,
		 SessionActivity                ,
         SessionEvent                   } from './types';

import { convertStringToDate            } from '../../dataTypes/timeManagment/utils';

import { getEnrichedCustomerFrontEvents } from '../../backendServices/customerFrontEventManagment/api';


const sortEventsByDate = (events: EnrichedCustomerFrontEvent[]): EnrichedCustomerFrontEvent[] => {
  return events.sort((a, b) => {
    const aDate = a.eventDate instanceof Date && !isNaN(a.eventDate.getTime()) ? a.eventDate : null;
    const bDate = b.eventDate instanceof Date && !isNaN(b.eventDate.getTime()) ? b.eventDate : null;

    if (aDate === null && bDate === null) return 0;
    if (aDate === null) return 1;
    if (bDate === null) return -1;

    return aDate.getTime() - bDate.getTime();
  });
};

///////////////////////////////////// GESTION DES REDIRECTIONS /////////////////////////////////////

export const getUrlRedirectionEvents = async (params: GetSessionsParams = {}): Promise<UrlRedirectionEvent  []> => {
	
  const result = await getEnrichedCustomerFrontEvents({
    ...params,
    eventFragment: "_REDIRECT_",
  });

  if (result?.payload)
   {
    return result.payload;
   }

  return [];
}

///////////////////////////////////// GESTION DES LIVES /////////////////////////////////////

/*
Ancien système :
 - __START_LIVE__:/diffusion:2025-07-02 09-58-59:0
 - __STOP_LIVE__:/diffusion:2025-07-02 09-58-59:0
 - __HEART_BEAT_LIVE__:/diffusion:Broadcasting:"Visionnage du live":2025-07-04 17-40-57:3

Nouveau système
 - __START_LIVE__:/diffusion:2025-07-02 09-58-59:ID  <- id du canal en BDD (1,....)
 - __STOP_LIVE__:/diffusion:2025-07-02 09-58-59:ID   <- id du canal en BDD
 - __HEART_BEAT_LIVE__:/diffusion:IdDevice:IdChannel:2025-07-04 17-40-57:1 <-heartbeatCount (pop)

*/

export const extractChannelId = (eventName: string): number => {
  const parts = eventName.split(":");
  return parts[0] === '__HEART_BEAT_LIVE__' ? parseInt(parts[3], 10) : parseInt(parts.pop() || '0');
};

export const extractHeartBeatCount = (eventName: string): number => {
  const parts = eventName.split(":");
  return parts[0] === '__HEART_BEAT_LIVE__' ? parseInt(parts.pop() || '0') : 0
};

export const extractLiveTimestamp = (eventName: string): number | null => {

  const parts      = eventName.split(":");
  let   dateString = ''

  if ( parts[0] === '__HEART_BEAT_LIVE__' )
        {
	     if (parts.length >= 5)
          {
           dateString = parts[4]; // "2024-09-16 07-38-29"
          }
		}
   else {
	     if (parts.length >= 2)
          {
           dateString = parts[2]; // "2024-09-16 07-38-29"
          }
        }


  try
   {
    const date = convertStringToDate(dateString);
    return date !== null && !isNaN(date.getTime()) ? date.getTime() : null;
   }
  catch
   {
    return null;
   }

  return null;
};

export const generateLiveSessions = (events: EnrichedCustomerFrontEvent[]): LiveSession[] => {

  const sessionsMap       : Map<string, LiveSession> = new Map();
  const sessions          : LiveSession[] = [];

  let currentSession      : LiveSession | null  | undefined = null;

  const sortedEvents = sortEventsByDate(events);

  sortedEvents.forEach(event => {

    const { eventDate , event: eventName , ipAddress , user, ipDetails } = event;

    const channelId      = extractChannelId      (eventName);
    const liveTimestamp  = extractLiveTimestamp  (eventName);
    extractHeartBeatCount (eventName)

    if (eventName.startsWith('__START_LIVE__'))
          {
           // Crée une nouvelle session de live

           currentSession = {
			 channelId             : channelId,
             startDate             : eventDate as Date,
             duration              : 0,
             isDurationExact       : false,
             isFinished            : false,
             eventCount            : 1,
             ipAddress             : ipAddress,
             ipAddressProviderName : ipDetails?.ipApiCom_isp     || "",
             ipAddressCity         : ipDetails?.ipApiCom_city    || "",
             ipAddressCountry      : ipDetails?.ipApiCom_country || "",
             ipAddressLat          : ipDetails?.ipApiCom_lat     || 0,
             ipAddressLon          : ipDetails?.ipApiCom_lon     || 0,
             userId                :  user?.id                               || 0,
             userEmail             :  user?.email                            || "",
             userFirstname         :  user?.firstname                        || "",
             userLastname          :  user?.lastname                         || "",
             userCreationIpAddress :  user?.creationIpAddress                || "",
             ipMismatch            : (user?.creationIpAddress !== ipAddress) || false,
            };

           sessions.push(currentSession);
           sessionsMap.set(`${channelId}-${liveTimestamp}-${ipAddress}-${(user?.id || 0)}`, currentSession! as LiveSession);
          }
     else {
           currentSession = sessionsMap.get(`${channelId}-${liveTimestamp}-${ipAddress}-${(user?.id || 0)}`);

           if ( currentSession !== null && currentSession !== undefined )
            {
                  if (eventName.startsWith('__HEART_BEAT_LIVE__'))
                   {
                    const delay = (new Date ()).getTime() - (eventDate as Date).getTime()

				    currentSession.duration        = ( (eventDate?.getTime() ?? 0) - (liveTimestamp ?? 0)) / 1000;
                    currentSession.isDurationExact = true;
					currentSession.isFinished      = delay > 70000;
                    currentSession.eventCount++;
                   }

             else if (eventName.startsWith('__STOP_LIVE__') )
                   {
				    currentSession.duration        = ( (eventDate?.getTime() ?? 0) - (liveTimestamp ?? 0)) / 1000;
                    currentSession.isDurationExact = true;
					currentSession.isFinished      = true;
                    currentSession.eventCount++;
                   }
            }
          }
  });

  return sessions;
};

export const getLiveSessions = async (params: GetSessionsParams = {}): Promise<LiveSession[]> => {

  const result = await getEnrichedCustomerFrontEvents({
    ...params,
    eventFragment: "_LIVE_",
  });


  if (result?.payload)
   {
    const sessions = generateLiveSessions(result.payload);

    return sessions;
   }

  return [];
};

///////////////////////////////////// GESTION DES REPLAYS /////////////////////////////////////

/*
__START_VIDEO__:/video:VideoViewer-onStart:196:2025-07-03 22-45-26:0:NaN
__PLAY_VIDEO__:/video:VideoViewer-onPlay:196:2025-07-03 22-45-26:0:NaN
__SEEK_VIDEO__:/video:VideoViewer-onSeek:196:2025-07-03 22-45-26:0.1:384.88000000000005:0.1
__HEART_BEAT_VIDEO__:/video:VideoViewer-onProgress:196:2025-07-03 22-45-26:976.795187:2293.0800000000004:976.795187:0.4259751892650932
__PAUSE_VIDEO__:/video:VideoViewer-onPause:196:2025-07-03 22-45-26:384.901333:384.901333
__END_VIDEO__:/video:VideoViewer-onEnded:196:2025-07-03 22-45-26:384.901333:384.901333

*/

export const extractVideoId = (eventName: string): number => {
  const parts = eventName.split(":");
  return parts.length > 3 ? parseInt(parts[3], 10) : 0;
};

export const extractVideoTimestamp = (eventName: string): number | null => {
  const parts = eventName.split(":");

  if (parts.length >= 5)
   {
    const dateString = parts[4]; // "2024-09-16 07-38-29"
    try
     {
      const date = convertStringToDate(dateString);
      return date !== null && !isNaN(date.getTime()) ? date.getTime() : null;
     }
    catch
     {
      return null; // Si une erreur survient
     }
  }

  return null;
};

export const extractTimecode = (eventName: string): number => {
  const parts = eventName.split(":");
  return parts.length > 5 ? parseFloat(parts[5]) : 0;
};

const updateSessionDurations = (sessions: ReplaySession[]): void => {

  sessions.forEach((session) => {
    const totalDuration = session.watchedSegments.reduce(
      (sum, segment) => sum + segment.duration,
      0
    );
    session.duration = totalDuration;
  });
};

export const generateReplaySessions = (events: EnrichedCustomerFrontEvent[]): ReplaySession[] => {

  const sessionsMap       : Map<string, ReplaySession> = new Map();
  const sessions          : ReplaySession[] = [];

  let currentSession      : ReplaySession | null  | undefined = null;
  let currentVideoSegment : VideoSegment  | null  | undefined = null;

  const sortedEvents = sortEventsByDate(events);

  sortedEvents.forEach(event => {

    const { eventDate , event: eventName , ipAddress , user, ipDetails , mediaDetails } = event;

    const videoId        = extractVideoId        (eventName);
    const videoTimestamp = extractVideoTimestamp (eventName);
    const timecode       = extractTimecode       (eventName)

    if (eventName.startsWith('__START_VIDEO__'))
          {
           // Crée une nouvelle session de replay

           currentSession = {
             startDate             : eventDate as Date,
             duration              : 0,
             isDurationExact       : false,
             isFinished            : false,
             eventCount            : 1,
             videoId               : videoId,
             videoTitle            : mediaDetails?.name || "",
             watchedSegments       : [],
             ipAddress             : ipAddress,
             ipAddressProviderName : ipDetails?.ipApiCom_isp     || "",
             ipAddressCity         : ipDetails?.ipApiCom_city    || "",
             ipAddressCountry      : ipDetails?.ipApiCom_country || "",
             ipAddressLat          : ipDetails?.ipApiCom_lat     || 0,
             ipAddressLon          : ipDetails?.ipApiCom_lon     || 0,
             userId                :  user?.id                               || 0,
             userEmail             :  user?.email                            || "",
             userFirstname         :  user?.firstname                        || "",
             userLastname          :  user?.lastname                         || "",
             userCreationIpAddress :  user?.creationIpAddress                || "",
             ipMismatch            : (user?.creationIpAddress !== ipAddress) || false,
            };

           currentVideoSegment = {
             startTime : timecode,
             endTime   : timecode,
             duration  : 0,
             event     : "Dbt "
            };

           (currentSession! as ReplaySession).watchedSegments.push(currentVideoSegment);

           sessions.push(currentSession);
           sessionsMap.set(`${videoId}-${videoTimestamp}-${ipAddress}-${(user?.id || 0)}`, currentSession! as ReplaySession);
          }
     else {
           currentSession = sessionsMap.get(`${videoId}-${videoTimestamp}-${ipAddress}-${(user?.id || 0)}`);

           if ( currentSession !== null && currentSession !== undefined )
            {
                  if (eventName.startsWith('__SEEK_VIDEO__'))
                   {
                    currentVideoSegment = {
                      startTime : timecode,
                      endTime   : timecode,
                      duration  : 0,
                      event     : "D "
                     };

                    (currentSession as ReplaySession).watchedSegments.push(currentVideoSegment);

                    currentSession.eventCount ++;

                   }

             else if (eventName.startsWith('__HEART_BEAT_VIDEO__'))
                   {
                    if ((currentSession as ReplaySession).watchedSegments.length > 0)
                     {
                      let currentVideoSegment = (currentSession as ReplaySession).watchedSegments[ (currentSession as ReplaySession).watchedSegments.length - 1 ];

                      currentVideoSegment.endTime  = timecode;
                      currentVideoSegment.duration = currentVideoSegment.endTime - currentVideoSegment.startTime;
                      currentVideoSegment.event    = currentVideoSegment.event+"B "
                     }

                    const delay = (new Date ()).getTime() - (eventDate as Date).getTime()

					currentSession.isFinished = delay > 70000
                    currentSession.eventCount ++;
                   }

             else if (eventName.startsWith('__STOP_VIDEO__') || eventName.startsWith('__END_VIDEO__') || eventName.startsWith('__CLICK__'))
                   {
                    if ((currentSession as ReplaySession).watchedSegments.length > 0)
                     {
                      let currentVideoSegment = (currentSession as ReplaySession).watchedSegments[ (currentSession as ReplaySession).watchedSegments.length - 1 ];

                      currentVideoSegment.endTime  = timecode;
                      currentVideoSegment.duration = currentVideoSegment.endTime - currentVideoSegment.startTime;
                      currentVideoSegment.event    = currentVideoSegment.event+ ( eventName.startsWith('__STOP_VIDEO__') ? "So " : ( eventName.startsWith('__END_VIDEO__') ? "Fin " : "C ") )
                     }

					currentSession.isFinished = true;
                    currentSession.eventCount ++;
                   }
            }
          }
  });

  updateSessionDurations (sessions)

  return sessions;
};

export const getReplaySessions = async ( params: GetSessionsParams = {} ): Promise<ReplaySession[]> => {

  const result = await getEnrichedCustomerFrontEvents({
    ...params,
    eventFragment: "_VIDEO_",
  });

  if (result?.payload)
   {
    const sessions = generateReplaySessions(result.payload);
    //replaySessionCache.set(cacheKey, sessions);

    return sessions;
   }

  return [];
 }


///////////////////////////////////// ANALYSE DE L'ACTIVITE /////////////////////////////////////

export const computeSessionActivity = (sessions: UserSession[]): SessionEvent[] => {

  const events: SessionEvent[] = [];

  sessions.forEach (session => {

    const start = session.startDate;
    const end   = new Date ( start.getTime() + session.duration * 1000 );

    let elementId: number = 0;

         if ('channelId' in session) { elementId = (session as LiveSession)  .channelId ?? 0; }
    else if ('videoId'   in session) { elementId = (session as ReplaySession).videoId   ?? 0; }

    /*

    if ( session.isFinished )
          {
           const end = new Date ( start.getTime() + session.duration * 1000);

           events.push ({
                           start     : start ,
                           end       : end     ,
                           ipAddress : session.ipAddress ,
                           userId    : session.userId    ,
                           elementId : elementId
                       });
          }
     else {
           events.push ({
                           start     : start ,
                           end       : null     ,
                           ipAddress : session.ipAddress ,
                           userId    : session.userId    ,
                           elementId : elementId
                       });
          }

    */

    // Start : d=0 et f=0 -> end  = null, on n'ajoute pas
    // Fin   : d>0 et f=1 -> end != null
    // HB    : d>0 et f=0 -> end  = null
    //         d>0 et f=1 -> end != null

    if ( session.duration > 0 )
     {
      if ( session.isFinished )
            {
             events.push ({
                                  start     : start ,
                                  end       : end     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                         });
            }
       else {
             events.push ({
                                  start     : start ,
                                  end       : null     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                         });
            }
     }

     /*
    if ( session.duration > 0 )
          {

           if ( session.isFinished )
                 {
                  events.push ({
                                  start     : start ,
                                  end       : end     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                              });
                 }
            else {
                  events.push ({
                                  start     : start ,
                                  end       : null     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                              });
                 }
          }
          */
  });

  events.sort((a, b) => a.start.getTime() - b.start.getTime());

  return events;
};

/*
   case 1 :   activity.end < period.start   =>   false
   --------

      Activity
   |------------|
                     |----------|
                        Period


   case 2 :   activity.start < period.end   =>   false
   --------

                                      Activity
                                   |------------|
                     |----------|
                        Period


   case 3 :   period.start < activity.start < period.end   =>   true
   --------

                               Activity
                            |------------|
                     |----------|
                        Period


   case 4 :  period.start < activity.end < period.end   =>   true
   --------

                Activity
             |------------|
                     |----------|
                        Period


   case 5 :  activity.start < period.start && period.end < activity.end   =>   true
   --------

                     Activity
             |----------------------|
                     |----------|
                        Period


   case 6 :  period.start < activity.start && activity.end < period.end   =>   true
   --------

                Activity
             |------------|
        |--------------------|
                Period

*/

const intersect = ( activity    : SessionEvent ,
                    periodStart : Date         ,
                    periodEnd   : Date         ): boolean => {

   let result: boolean = true;

   if ( activity.start > periodEnd )
         {
          result = false;  // C'est déjà passé'
         }
    else {
          if ( activity.end === null )
                {
                 result = true;  // C'est en cours'
                                 // on devrait tester now < periodStart  -> renvoie false si vrai
                }
           else {
                 if ( activity.end < periodStart )
                       {
                        result = false; // Ce n'est pas encore passé'
                       }
                  else {
                        result = true; // Intersection
                       }
                }
         }

   return result;
}

export const computeSessionActivityEvolution = (
  activities: SessionEvent[],
  timestep: string,
  start?: Date,
  end?: Date
): SessionActivity[] => {
  if (activities.length === 0) {
    return [];
  }

  let timestepMs: number;
  switch (timestep) {
    case '1 minute':   timestepMs =                    60 * 1000; break;
    case '5 minutes':  timestepMs =                5 * 60 * 1000; break;
    case '10 minutes': timestepMs =               10 * 60 * 1000; break;
    case '1 heure':    timestepMs =               60 * 60 * 1000; break;
    case '6 heures':   timestepMs =           6 * 60 * 60 * 1000; break;
    case '12 heures':  timestepMs =          12 * 60 * 60 * 1000; break;
    case '1 jour':     timestepMs =          24 * 60 * 60 * 1000; break;
    case '1 semaine':  timestepMs =      7 * 24 * 60 * 60 * 1000; break;
    case '1 mois':     timestepMs =     30 * 24 * 60 * 60 * 1000; break;
    case '6 mois':     timestepMs = 6 * 30 * 24 * 60 * 60 * 1000; break;
    case '1 an':       timestepMs =    365 * 24 * 60 * 60 * 1000; break;
    default: return [];
  }

  // Fonction pour arrondir une date vers le bas selon le timestep, en préservant le fuseau horaire
  const floorToTimestep = (date: Date): Date => {
    if (timestep === '1 jour' || timestep === '1 semaine' || timestep === '1 mois' || timestep === '1 an') {
      // Pour les intervalles de jours ou plus, on arrondit à minuit local
      const result = new Date(date);
      result.setHours(0, 0, 0, 0);
      
      if (timestep === '1 semaine') {
        // Arrondir au début de la semaine (lundi)
        const dayOfWeek = result.getDay();
        const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Dimanche = 0, on veut lundi
        result.setDate(result.getDate() - daysToSubtract);
      } else if (timestep === '1 mois') {
        // Arrondir au 1er du mois
        result.setDate(1);
      } else if (timestep === '1 an') {
        // Arrondir au 1er janvier
        result.setMonth(0, 1);
      }
      
      return result;
    } else {
      // Pour les intervalles en heures/minutes, on utilise l'approche par timestamp
      // mais en créant une date de référence à minuit pour éviter les problèmes de fuseau horaire
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      
      const msFromStartOfDay = date.getTime() - startOfDay.getTime();
      const flooredMsFromStartOfDay = Math.floor(msFromStartOfDay / timestepMs) * timestepMs;
      
      return new Date(startOfDay.getTime() + flooredMsFromStartOfDay);
    }
  };

  // Fonction pour arrondir une date vers le haut selon le timestep
  const ceilToTimestep = (date: Date): Date => {
    const floored = floorToTimestep(date);
    
    // Si la date est déjà alignée, on retourne telle quelle
    if (floored.getTime() === date.getTime()) {
      return new Date(date);
    }
    
    // Sinon on ajoute un timestep
    return new Date(floored.getTime() + timestepMs);
  };

  // Calcul des dates de début et fin
  const startDate = start 
    ? floorToTimestep(start)
    : floorToTimestep(activities[0].start);

  const endDate = end 
    ? ceilToTimestep(end)
    : ceilToTimestep(activities[activities.length - 1].end ?? new Date());

  const result: SessionActivity[] = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    // Calculer la prochaine date en ajoutant le timestep
    const nextDate = new Date(currentDate.getTime() + timestepMs);
    
    const uniqueTriplets = new Set<string>();
    
    // Parcourir toutes les activités pour cette période
    for (let i = 0; i < activities.length; i++) {
      if (intersect(activities[i], currentDate, nextDate)) {
        const triplet = `${activities[i].userId}-${activities[i].ipAddress}-${activities[i].elementId}`;
        uniqueTriplets.add(triplet);
      }
    }

    result.push({
      date: new Date(currentDate),
      activity: uniqueTriplets.size,
    });

    currentDate = nextDate;
  }

  return result;
};



///////////////////////////////////// ANALYSE DE L'ACTIVITE /////////////////////////////////////

export const computeActivity = (sessions: UrlRedirectionEvent[]): UrlRedirectionEvent[] => {

  const events: UrlRedirectionEvent[] = [];

  // sessions.forEach (session => {

    // const start = session.startDate;
    // const end   = new Date ( start.getTime() + session.duration * 1000 );

    // let elementId: number = 0;

         // if ('channelId' in session) { elementId = (session as LiveSession)  .channelId ?? 0; }
    // else if ('videoId'   in session) { elementId = (session as ReplaySession).videoId   ?? 0; }

    /*

    if ( session.isFinished )
          {
           const end = new Date ( start.getTime() + session.duration * 1000);

           events.push ({
                           start     : start ,
                           end       : end     ,
                           ipAddress : session.ipAddress ,
                           userId    : session.userId    ,
                           elementId : elementId
                       });
          }
     else {
           events.push ({
                           start     : start ,
                           end       : null     ,
                           ipAddress : session.ipAddress ,
                           userId    : session.userId    ,
                           elementId : elementId
                       });
          }

    */

    // Start : d=0 et f=0 -> end  = null, on n'ajoute pas
    // Fin   : d>0 et f=1 -> end != null
    // HB    : d>0 et f=0 -> end  = null
    //         d>0 et f=1 -> end != null

    // if ( session.duration > 0 )
     // {
      // if ( session.isFinished )
            // {
             // events.push ({
                                  // start     : start ,
                                  // end       : end     ,
                                  // ipAddress : session.ipAddress ,
                                  // userId    : session.userId    ,
                                  // elementId : elementId
                         // });
            // }
       // else {
             // events.push ({
                                  // start     : start ,
                                  // end       : null     ,
                                  // ipAddress : session.ipAddress ,
                                  // userId    : session.userId    ,
                                  // elementId : elementId
                         // });
            // }
     // }

     /*
    if ( session.duration > 0 )
          {

           if ( session.isFinished )
                 {
                  events.push ({
                                  start     : start ,
                                  end       : end     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                              });
                 }
            else {
                  events.push ({
                                  start     : start ,
                                  end       : null     ,
                                  ipAddress : session.ipAddress ,
                                  userId    : session.userId    ,
                                  elementId : elementId
                              });
                 }
          }
          */
  // });

  // events.sort((a, b) => a.start.getTime() - b.start.getTime());

  return events;
};

/*
   case 1 :   activity.end < period.start   =>   false
   --------

      Activity
   |------------|
                     |----------|
                        Period


   case 2 :   activity.start < period.end   =>   false
   --------

                                      Activity
                                   |------------|
                     |----------|
                        Period


   case 3 :   period.start < activity.start < period.end   =>   true
   --------

                               Activity
                            |------------|
                     |----------|
                        Period


   case 4 :  period.start < activity.end < period.end   =>   true
   --------

                Activity
             |------------|
                     |----------|
                        Period


   case 5 :  activity.start < period.start && period.end < activity.end   =>   true
   --------

                     Activity
             |----------------------|
                     |----------|
                        Period


   case 6 :  period.start < activity.start && activity.end < period.end   =>   true
   --------

                Activity
             |------------|
        |--------------------|
                Period

*/


export const computeActivityEvolution = (
  activities: UrlRedirectionEvent[],
  timestep: string,
  start?: Date,
  end?: Date
): SessionActivity[] => {
  if (activities.length === 0) {
    return [];
  }

  // Le pas de temps ne sert plus au calcul, mais reste un critère de validation :
  // un timestep inconnu n'a pas d'évolution à retourner.
  switch (timestep) {
    case '1 minute':
    case '5 minutes':
    case '10 minutes':
    case '1 heure':
    case '6 heures':
    case '12 heures':
    case '1 jour':
    case '1 semaine':
    case '1 mois':
    case '6 mois':
    case '1 an':       break;
    default: return [];
  }

  // Fonction pour arrondir une date vers le bas selon le timestep, en préservant le fuseau horaire

  // Fonction pour arrondir une date vers le haut selon le timestep
  // const ceilToTimestep = (date: Date): Date => {
    // const floored = floorToTimestep(date);
    
    // Si la date est déjà alignée, on retourne telle quelle
    // if (floored.getTime() === date.getTime()) {
      // return new Date(date);
    // }
    
    // Sinon on ajoute un timestep
    // return new Date(floored.getTime() + timestepMs);
  // };

  // Calcul des dates de début et fin
  // const startDate = start 
    // ? floorToTimestep(start)
    // : floorToTimestep(activities[0].eventDate);

  // const endDate = end 
    // ? ceilToTimestep(end)
    // : ceilToTimestep(activities[activities.length - 1].eventDate ?? new Date());

  const result: SessionActivity[] = [];
  // let currentDate = new Date(startDate);

  // while (currentDate <= endDate) {
  //  Calculer la prochaine date en ajoutant le timestep
    // const nextDate = new Date(currentDate.getTime() + timestepMs);
    
    // const uniqueTriplets = new Set<string>();
    
   // Parcourir toutes les activités pour cette période
    // for (let i = 0; i < activities.length; i++) {
      // if (intersect2(activities[i], currentDate, nextDate)) {
        // const triplet = `${activities[i].id}-${activities[i].ipAddress}`;
        // uniqueTriplets.add(triplet);
      // }
    // }

    // result.push({
      // date: new Date(currentDate),
      // activity: uniqueTriplets.size,
    // });

    // currentDate = nextDate;
  // }

  return result;
};
